module.exports = __webpack_public_path__ + "img/production-list.78a5133d.png";